// extracted by mini-css-extract-plugin
export default {"group":"Tooltip--group--+mCJX","infoBox":"Tooltip--infoBox--QnbSw","value":"Tooltip--value--RmlpA"};